import React from 'react';

import ProjectConfig from '../constants';

/**
 * Pantalla de mantenimiento, sin Chakra.
 *
 * El fondo sigue saliendo de `ProjectConfig`: `#F5F5F5` no tiene token equivalente ni en chirigota
 * ni en Proa, y escribir el hex aquí lo dejaría en dos sitios que se desincronizan. Cuando ese
 * color entre en el sistema, se cambia en un solo punto.
 *
 * `fontSize="md"` de Chakra es 1rem, que en Tailwind es `text-base` y no `text-md` — esa clase no
 * existe y habría caído sin tamaño.
 */
const Maintenance: React.FC = () => (
	<div
		className="flex h-screen flex-col items-center justify-center"
		style={{ backgroundColor: ProjectConfig.ARCA_COLORS.LIGHT_GREY_03 }}
	>
		<img src="/imgs/LOGO_VERDE_2.svg" alt="Logo Arca" className="mb-4 size-[150px]" />
		<p className="mb-2 text-2xl font-bold">Estamos en mantenimiento</p>
		<p className="mb-4 text-lg">Pronto estaremos de vuelta.</p>
		<p className="text-base">
			Para cualquier urgencia, pueden contactar con{' '}
			<a href={`mailto:${ProjectConfig.ARCA_CONTACT.EMAIL}`}>{ProjectConfig.ARCA_CONTACT.EMAIL}</a>
		</p>
	</div>
);

export default Maintenance;
